import { render, staticRenderFns } from "./TableFinance.vue?vue&type=template&id=b6790ea8&scoped=true"
import script from "./TableFinance.vue?vue&type=script&lang=js"
export * from "./TableFinance.vue?vue&type=script&lang=js"
import style0 from "./TableFinance.vue?vue&type=style&index=0&id=b6790ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6790ea8",
  null
  
)

export default component.exports